// extracted by mini-css-extract-plugin
export default {"main":"styles_main__H64lh","header":"styles_header__y2I+k","headerBox":"styles_headerBox__Auj5y"};